"use strict";

export function initInScope ($scope) {
    import('tilt.js').then(function () {
        $scope.find('.js-tilt-animation').tilt({
            maxTilt: 3,
            speed: 1000
        });

    });
}